import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import hathayoga from "../images/hatha yoga.png"
import vinYoga from "../images/vinyasa yoga.png"
import kYoga from "../images/kundalini yoga.png"
import inYoga from "../images/intutive yoga.png"
import aromaYoga from "../images/aromayoga.jpeg"
import slowYoga from "../images/slow yoga.png"


const HealthAndFitness = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        // minHeight: "100vh",
        py: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Playfair Display', serif",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: 400,
          color: "#000",
          mb: 4,
          letterSpacing: "1px",
          fontFamily: "'Playfair Display', serif",
        }}
      >
        Dive in the World of Health & Fitness
      </Typography>
      {/* <Typography
        variant="body1"
        sx={{
          maxWidth: "600px",
          color: "#666",
          mb: 6,
          lineHeight: 1.6,
          fontFamily: "'Playfair Display', serif",
        }}
      >
        YOGA - THE GREATEST MEDICINE: Yoga serves as a tool for overcoming many
        health issues. It is more powerful when done with Prana's yoga. Several
        wonders are achieved with this yogic method.
      </Typography> */}
      <Grid container spacing={4} justifyContent="center">
        {/* Hatha Yoga */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={hathayoga} // Replace with Hatha Yoga icon
              alt="Hatha Yoga"
              sx={{
                width: "48px",
                height: "48px",
                filter: "hue-rotate(330deg)",
                mb: 1,
              }}
            />
            <Typography variant="body2" sx={{ color: "orange" }}>
              Hatha Yoga
            </Typography>
          </Box>
        </Grid>
        {/* Vinyasa Yoga */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={vinYoga} // Replace with Vinyasa Yoga icon
              alt="Vinyasa Yoga"
              sx={{
                width: "48px",
                height: "48px",
                filter: "hue-rotate(330deg)",
                mb: 1,
              }}
            />
            <Typography variant="body2" sx={{ color: "orange" }}>
              Vinyasa Yoga
            </Typography>
          </Box>
        </Grid>
        {/* Kundalini Yoga */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={kYoga} // Replace with Kundalini Yoga icon
              alt="Kundalini Yoga"
              sx={{
                width: "48px",
                height: "48px",
                filter: "hue-rotate(330deg)",
                mb: 1,
              }}
            />
            <Typography variant="body2" sx={{ color: "orange" }}>
              Kundalini Yoga
            </Typography>
          </Box>
        </Grid>
        {/* Intuitive Yoga */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={inYoga} // Replace with Intuitive Yoga icon
              alt="Intuitive Yoga"
              sx={{
                width: "48px",
                height: "48px",
                filter: "hue-rotate(330deg)",
                mb: 1,
              }}
            />
            <Typography variant="body2" sx={{ color: "orange" }}>
              Intuitive Yoga
            </Typography>
          </Box>
        </Grid>
        {/* Aroma Yoga */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={aromaYoga} // Replace with Aroma Yoga icon
              alt="Aroma Yoga"
              sx={{
                width: "48px",
                height: "58px",
                filter: "hue-rotate(330deg)",
                mb: 1,
              }}
            />
            <Typography variant="body2" sx={{ color: "orange" }}>
              Aroma Yoga
            </Typography>
          </Box>
        </Grid>
        {/* Slow Yoga */}
        <Grid item xs={4}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={slowYoga} // Replace with Slow Yoga icon
              alt="Slow Yoga"
              sx={{
                width: "48px",
                height: "48px",
                filter: "hue-rotate(330deg)",
                mb: 1,
              }}
            />
            <Typography variant="body2" sx={{ color: "orange" }}>
              Slow Yoga
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default HealthAndFitness;
